import { render, staticRenderFns } from "./ArticleData.vue?vue&type=template&id=9bf15804&scoped=true"
import script from "./ArticleData.vue?vue&type=script&lang=js"
export * from "./ArticleData.vue?vue&type=script&lang=js"
import style0 from "./ArticleData.vue?vue&type=style&index=0&id=9bf15804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f87e3863bbacd24b3d835a89ae544fd6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf15804",
  null
  
)

export default component.exports